module.exports = __webpack_public_path__ + "static/img/icon-docMoneyEnlarge.f75a1ded.png";